import type { EntityConfig } from '../types'

export const meterEntity: EntityConfig = {
  id: 'meter',
  displayName: 'Meter',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'draft', label: 'Draft' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'inactive', label: 'Inactive', color: 'neutral' },
      { value: 'draft', label: 'Draft', color: 'warning' },
    ],
    mappings: {
      all: ['active', 'inactive', 'draft'],
      active: ['active'],
      inactive: ['inactive'],
      draft: ['draft'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'status',
    'dateRange',
    'search',
  ]
}
